import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { UserSessionContext } from 'components/UserSession';
import { BoothLightboxContext } from 'pages/booths/components/BoothLightboxContext';

import WatchNowIcon from 'components/icons/WatchNow';
import ActionButton from './ActionButton';

const StyledBtnText = styled.div`
  margin-left: 10px;
`;

const WatchNowButton = ({
  id,
  name,
  url,
  cfStreamId,
}) => {
  const videoContext = useContext(BoothLightboxContext);
  const { userSession } = useContext(UserSessionContext);

  const onWatchNowClick = () => {
    window.trackingEvent('MainMenu_Webinar', `PlayWebinarVideo_${userSession.email}`, `Webinar-${id}-${name}_${url || ''}`);
    if (cfStreamId) {
      videoContext.setCfStreamId(cfStreamId);
    } else if (url.endsWith('mp4')) {
      videoContext.setUrl(url);
    } else {
      window.open(url, '_blank', 'noopener=yes,noreferrer=yes');
    }
  };

  return (
    <ActionButton onClick={onWatchNowClick}>
      <WatchNowIcon color="#FFF" />
      <StyledBtnText>
        Watch now
      </StyledBtnText>
    </ActionButton>
  );
};

WatchNowButton.propTypes = {
  url: PropTypes.string.isRequired,
  cfStreamId: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};

export default WatchNowButton;
